<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="container-fluid glb-popup payment-popup">
  <h2>Reconcile Captured</h2>

  <button mat-icon-button (click)="onCancel()" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>

  <p class="mb-2" style="font-size:0.9rem;">
    Use this when you've already captured an auth manually from the
    <strong>Authorize.net dashboard</strong> and want our DB to catch up. We'll verify
    the gateway state before flipping the row to <code>PC + A</code> and triggering the
    downstream cascade (E4, NACHA, owner statement, QBO sync).
  </p>
  <div class="p-2 mb-3" style="background:#fff7ed; border:1px solid #fed7aa; border-radius:4px; font-size:0.8rem;">
    <strong>Note:</strong> if you <em>haven't</em> captured at the Authorize.net dashboard yet, this won't work —
    the gateway will still report the auth as uncaptured and we'll refuse to mark the row paid.
    To capture <em>through our app</em> instead, close this and click <strong>Authorize Capture</strong>
    (or wait — the 5-min scheduler will capture it automatically).
  </div>

  <!-- Inline status surface — shows the actual server message (success or
       failure) so the user knows exactly why a reconcile did or didn't go
       through. The toast still fires alongside this. -->
  @if (resultMessage) {
    <div class="p-3 mb-3" [ngStyle]="{
           'background': resultSuccess ? '#ecfdf5' : '#fef2f2',
           'border':     resultSuccess ? '1px solid #6ee7b7' : '1px solid #fca5a5',
           'border-radius': '4px'
         }">
      <div class="d-flex align-items-start justify-content-between">
        <div>
          <div class="fw-bold mb-1" [ngStyle]="{ 'color': resultSuccess ? '#065f46' : '#991b1b' }">
            <i class="pi" [ngClass]="resultSuccess ? 'pi-check-circle' : 'pi-exclamation-triangle'"
               style="margin-right:6px;"></i>
            {{ resultSuccess ? 'Reconciled' : 'Reconcile failed' }}
          </div>
          <div style="font-size:0.85rem; line-height:1.4;">{{ resultMessage }}</div>
          @if (resultGatewayStatus) {
            <div class="mt-1" style="font-size:0.8rem; color:#475569;">
              Gateway state: <code>{{ resultGatewayStatus }}</code>
            </div>
          }
        </div>
        <button type="button"
                (click)="dismissResult()"
                style="border:0; background:transparent; cursor:pointer; font-size:1rem; padding:0 4px;"
                [attr.aria-label]="'Dismiss message'">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
  }

  @if (candidates.length === 0) {
    <div class="p-3" style="background:#f0f9ff; border:1px solid #bfdbfe; border-radius:4px;">
      <p class="mb-2" style="font-weight:600;">No rows currently need reconciling on this order.</p>
      <p class="mb-0" style="font-size:0.85rem; color:#475569;">
        The hourly Authorize.net poll job auto-detects out-of-band captures within an hour,
        so this manual tool is only needed when you can't wait that long.
      </p>
    </div>
  } @else {
    <div class="mb-3">
      <label for="candidatePicker" class="fw-bold mb-1 d-block">Pick a row</label>
      <select id="candidatePicker"
              class="form-select"
              [(ngModel)]="selectedPaymentConfirmId">
        <option [ngValue]="null">— select —</option>
        @for (c of candidates; track c.paymentConfirmId) {
          <option [ngValue]="c.paymentConfirmId">{{ candidateLabel(c) }}</option>
        }
      </select>
    </div>

    @if (selectedCandidate) {
      <div class="p-3 mb-3" style="background:#f8fafc; border:1px solid #e2e8f0; border-radius:4px; font-size:0.85rem;">
        <div><strong>paymentConfirmId:</strong> {{ selectedCandidate.paymentConfirmId }}</div>
        <div><strong>Auth transaction id:</strong> {{ selectedCandidate.authnetTxnId }}</div>
        <div><strong>Amount:</strong> ${{ selectedCandidate.amount }}</div>
        <div><strong>Card:</strong> {{ selectedCandidate.last4 }}</div>
        <div><strong>Current state:</strong> {{ selectedCandidate.type }} + {{ selectedCandidate.result }}</div>
      </div>
    }
  }

  <div class="row reservation-btn">
    <div class="col-12">
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">
          {{ resultSuccess === true ? 'Close & Reload' : 'Cancel' }}
        </button>
        <button type="button"
                class="btn btn-primary"
                [disabled]="!selectedPaymentConfirmId || submitting || candidates.length === 0 || resultSuccess === true"
                (click)="onSubmit()">
          {{ submitting ? 'Reconciling…' : 'Reconcile' }}
        </button>
      </div>
    </div>
  </div>
</div>
